import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, where } from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { auth } from '../firebase/firebase';

const customersCollectionRef = collection(db, 'customers');

export const getCustomers = async () => {
  try {
    // Get the current user ID
    const userId = auth.currentUser?.uid;
    
    if (!userId) {
      throw new Error('User not authenticated');
    }
    
    // Create a query against the collection to only get this user's customers
    const q = query(customersCollectionRef, where("userId", "==", userId));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => {
      const data = doc.data();
      // Format the timestamp if it exists
      const updatedAt = data.updatedAt?.toDate ? 
        data.updatedAt.toDate() : 
        data.updatedAt;
        
      return {
        id: doc.id,
        name: data.name || '',
        email: data.email || '',
        phone: data.phone || '',
        tags: data.tags || [],
        status: data.status || 'active',
        updatedAt: updatedAt,
        userId: data.userId
      };
    });
  } catch (error) {
    console.error("Error getting customers: ", error);
    throw error;
  }
};

export const addCustomer = async (customer) => {
  try {
    // Add userId and updatedAt to the customer data
    const enhancedCustomer = {
      ...customer,
      userId: auth.currentUser?.uid,
      updatedAt: new Date()
    };
    
    return await addDoc(customersCollectionRef, enhancedCustomer);
  } catch (error) {
    console.error("Error adding customer: ", error);
    throw error;
  }
};

export const updateCustomer = async (id, updatedCustomer) => {
  try {
    const customerDoc = doc(db, 'customers', id);
    // Add updatedAt timestamp when updating
    const enhancedCustomer = {
      ...updatedCustomer,
      updatedAt: new Date()
    };
    
    // Remove the id field as it shouldn't be part of the document data
    delete enhancedCustomer.id;
    
    return await updateDoc(customerDoc, enhancedCustomer);
  } catch (error) {
    console.error("Error updating customer: ", error);
    throw error;
  }
};

export const deleteCustomer = async (id) => {
  const customerDoc = doc(db, 'customers', id);
  return await deleteDoc(customerDoc);
};
